// src/OddManOut.js

import React, { useState, useEffect } from 'react';
import './OddManOut.css';

const questionsData = [
  {
    question: "Find the odd man out:",
    options: ["Apple", "Banana", "Carrot", "Grapes"],
    answer: "Carrot"
  },
  {
    question: "Find the odd man out:",
    options: ["Dog", "Cat", "Bird", "Lion"],
    answer: "Bird"
  },
  {
    question: "Find the odd man out:",
    options: ["Blue", "Green", "Yellow", "Dog"],
    answer: "Dog"
  },
  // Add more questions as needed
  {
    question: "Find the odd man out:",
    options: ["Monday", "Tuesday", "January", "Wednesday"],
    answer: "January"
  },
  {
    question: "Find the odd man out:",
    options: ["Summer", "Winter", "Autumn", "June"],
    answer: "June"
  },
  {
    question: "Find the odd man out:",
    options: ["Football", "Cricket", "Basketball", "Car"],
    answer: "Car"
  },
  {
    question: "Find the odd man out:",
    options: ["Rose", "Lily", "Sunflower", "Elephant"],
    answer: "Elephant"
  },
  {
    question: "Find the odd man out:",
    options: ["Doctor", "Teacher", "Engineer", "Cat"],
    answer: "Cat"
  },
  {
    question: "Find the odd man out:",
    options: ["Math", "Science", "History", "Dog"],
    answer: "Dog"
  },
  {
    question: "Find the odd man out:",
    options: ["Lion", "Tiger", "Bear", "Bus"],
    answer: "Bus"
  },
  {
    question: "Find the odd man out:",
    options: ["Rose", "Tulip", "Lotus", "Car"],
    answer: "Car"
  },
  {
    question: "Find the odd man out:",
    options: ["Banana", "Apple", "Orange", "Truck"],
    answer: "Truck"
  },
  {
    question: "Find the odd man out:",
    options: ["Cat", "Dog", "Bird", "Television"],
    answer: "Television"
  },
  {
    question: "Find the odd man out:",
    options: ["Carrot", "Potato", "Tomato", "Train"],
    answer: "Train"
  },
  {
    question: "Find the odd man out:",
    options: ["New York", "Los Angeles", "Chicago", "Soccer"],
    answer: "Soccer"
  },
  {
    question: "Find the odd man out:",
    options: ["Bread", "Butter", "Milk", "Airplane"],
    answer: "Airplane"
  },
  {
    question: "Find the odd man out:",
    options: ["Book", "Pen", "Pencil", "Tiger"],
    answer: "Tiger"
  },
  {
    question: "Find the odd man out:",
    options: ["Chair", "Table", "Sofa", "Bird"],
    answer: "Bird"
  },
  {
    question: "Find the odd man out:",
    options: ["Pizza", "Burger", "Pasta", "Bus"],
    answer: "Bus"
  },
  {
    question: "Find the odd man out:",
    options: ["Lion", "Tiger", "Elephant", "Computer"],
    answer: "Computer"
  },
  {
    question: "Find the odd man out:",
    options: ["Red", "Blue", "Green", "Television"],
    answer: "Television"
  },
  {
    question: "Find the odd man out:",
    options: ["Car", "Bus", "Bicycle", "Apple"],
    answer: "Apple"
  },
  {
    question: "Find the odd man out:",
    options: ["Football", "Basketball", "Soccer", "Tree"],
    answer: "Tree"
  },
  {
    question: "Find the odd man out:",
    options: ["Winter", "Summer", "Spring", "Bird"],
    answer: "Bird"
  },
  {
    question: "Find the odd man out:",
    options: ["Orange", "Grapes", "Apple", "Train"],
    answer: "Train"
  },
  {
    question: "Find the odd man out:",
    options: ["Rose", "Sunflower", "Lily", "Car"],
    answer: "Car"
  },
  {
    question: "Find the odd man out:",
    options: ["Math", "Science", "History", "Lion"],
    answer: "Lion"
  },
  {
    question: "Find the odd man out:",
    options: ["Car", "Bus", "Bicycle", "Banana"],
    answer: "Banana"
  },
  {
    question: "Find the odd man out:",
    options: ["Dog", "Cat", "Bird", "Computer"],
    answer: "Computer"
  },
  {
    question: "Find the odd man out:",
    options: ["Apple", "Orange", "Grapes", "Bus"],
    answer: "Bus"
  },
  {
    question: "Find the odd man out:",
    options: ["Potato", "Carrot", "Onion", "Airplane"],
    answer: "Airplane"
  },
  {
    question: "Find the odd man out:",
    options: ["Red", "Blue", "Green", "Tiger"],
    answer: "Tiger"
  },
  {
    question: "Find the odd man out:",
    options: ["Monday", "Tuesday", "Sunday", "Apple"],
    answer: "Apple"
  },
  {
    question: "Find the odd man out:",
    options: ["Bread", "Butter", "Jam", "Lion"],
    answer: "Lion"
  },
  {
    question: "Find the odd man out:",
    options: ["Doctor", "Teacher", "Engineer", "Soccer"],
    answer: "Soccer"
  }
];

const OddManOut = () => {
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [selectedOption, setSelectedOption] = useState('');
  const [result, setResult] = useState('');
  const [showResult, setShowResult] = useState(false);

  const readQuestionAndOptions = () => {
    const currentQuestion = questionsData[currentQuestionIndex];
    const utterance = new SpeechSynthesisUtterance(currentQuestion.question);
    speechSynthesis.speak(utterance);

    currentQuestion.options.forEach((option, index) => {
      const optionUtterance = new SpeechSynthesisUtterance(`Option ${index + 1}: ${option}`);
      speechSynthesis.speak(optionUtterance);
    });
  };

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
  };

  const handleSubmit = () => {
    const currentQuestion = questionsData[currentQuestionIndex];
    const isCorrect = currentQuestion.answer === selectedOption;
    if (isCorrect) {
      setResult('Correct!');
    } else {
      setResult(`Wrong! The correct answer is ${currentQuestion.answer}.`);
    }
    setShowResult(true);

    const utterance = new SpeechSynthesisUtterance(
      isCorrect ? 'Correct!' : `Wrong! The correct answer is ${currentQuestion.answer}.`
    );
    speechSynthesis.speak(utterance);
  };

  const handleNext = () => {
    const nextIndex = Math.floor(Math.random() * questionsData.length);
    setCurrentQuestionIndex(nextIndex);
    setSelectedOption('');
    setShowResult(false);
  };

  const currentQuestion = questionsData[currentQuestionIndex];

  return (
    <div className="odd-man-out">
      <h1>Odd Man Out</h1>
      <div className="question">
        <p>{currentQuestion.question}</p>
      </div>
      <div className="options">
        {currentQuestion.options.map((option, index) => (
          <label key={index}>
            <input
              type="radio"
              value={option}
              checked={selectedOption === option}
              onChange={handleOptionChange}
            />
            {option}
          </label>
        ))}
      </div>
      {showResult && (
        <div className="result">
          <p>{result}</p>
        </div>
      )}
      <div className="buttons">
        <button onClick={readQuestionAndOptions}>Read Question</button>
        <button onClick={handleSubmit}>Submit</button>
        <button onClick={handleNext}>Next</button>
      </div>
    </div>
  );
};

export default OddManOut;
